"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logout = void 0;
var assert_1 = require("./utils/assert");
var redirect_1 = require("./utils/redirect");
var serialize_1 = require("./utils/serialize");
var logout = function (options) {
    assert_1.assert(options, ['client_id', 'url', 'redirect_url']);
    var params = {
        client_id: options.client_id,
        redirect_uri: options.redirect_url,
    };
    var url = options.url + "/oauth/logout?" + serialize_1.stringify(params);
    var fn = options.onLogoutRedirect || redirect_1.redirect;
    return fn(url);
};
exports.logout = logout;
//# sourceMappingURL=logout.js.map